<template>
  <div>
    <news-view :item="item" :files="files" :boardType="5"/>
  </div>
</template>

<script>
import NewsView from '@/components/pages/news/view/index'

export default {
  name: 'news-food-view',
  components: { NewsView },
  description: '공지사항 - 상세',
  data: function() {
    const query = this.$route.query
    return {
      params: {
        foodNo: Number(query.foodNo)
      },
      item: {},
      files: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      this.params.no = Number(this.$route.query.foodNo)
      this.params.boardType = 5
      const res = await this.$BoardSvc.fetchData(this.params)
      if (res.code === 1) {
        this.item = res.entity
      }
    },
    fnBack: function() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
